import { render, staticRenderFns } from "./DemoComp2.vue?vue&type=template&id=5f2d3ec5"
import script from "./DemoComp2.vue?vue&type=script&lang=js"
export * from "./DemoComp2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports